module.exports = function ($compile, moveFocus) {
    return {
        restrict: 'E',
        transclude: true,
        scope: {
            // loading variable
            loading: '=?',
            spinnerClass: '@?',
            buttonClass: '@?'
        },
        compile(tElem, tAttrs) {
            let loading = tElem.find('._oly-button-loading');

            // apply oly next tab attribute nextTab
            if (tAttrs.nextTab) {
                loading.attr('oly-next-tab', tAttrs.nextTab);
            }

            return {
                post(scope, element, iAttrs, controller, transcludeFn) {
                    transcludeFn(function (clone) {
                        if (iAttrs.nextTab) {
                            clone.attr('oly-next-tab', iAttrs.nextTab);
                        }
                        element.find('._oly-button-transclude').html($compile(clone)(scope));
                    });

                    loading = element.find('._oly-button-loading');

                    // check if there is a link with an href
                    let button = element.find('[href]');

                    if (button && button.length > 0) {
                        // hack for IE - hide link when click
                        button.on('click', function () {
                            if (loading.find('.spinner').length > 0) {
                                button.hide();
                                loading.show();
                            }
                        });
                    } else {
                        // if there is no element with [href], we look for an element with button class
                        button = element.find('.button');
                    }

                    scope.btnClass = button.attr('class');

                    // default loading state
                    if (!scope.loading) {
                        scope.loading = {
                            state: false,
                            message: 'loading, please wait'
                        };
                    } else {
                        scope.$watch(function () { return scope.loading; }, function (newVal, oldVal) {
                            if (newVal.state && !oldVal.state) {
                                moveFocus(loading);
                            }
                        });
                    }
                }
            };
        },
        template: require('./button-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/button/button-directive.js
 **/